import apiClient from "QueryClient/axiosClient";

export const editSlots = (data) => {
  return apiClient.put("/oneGradSlot/editSlot", data);
};

export const confirmSlot = (data) => {
  return apiClient.put("/oneGradSlot/confirmSlot", data);
};
